import { Avatar, SxProps, useTheme } from "@mui/material"
import { ReactElement } from "react"

import { LCT_METADATA_DISPATCHER, MULTIPLE_LCTS } from "./lctMetadataDispatcher"
import { UNKNOWN_STATUS } from "../../../constants/generalConstants"

interface ILctAvatarProps {
    lcts: string[]
    success?: boolean
    sx?: SxProps
}

/**
 * Displays LCT icon avatar, using an input array `lcts` to decide which icon to
 * render. If multiple LCTs are present, a bespoke multiple LCT avatar is displayed.
 * If an unrecognised LCT is supp;ied, a fallback component is rendered
 */
const LctAvatar = ({ lcts, success, sx }: ILctAvatarProps): ReactElement => {
    const theme = useTheme()
    const unknownLct = LCT_METADATA_DISPATCHER[UNKNOWN_STATUS]
    let lctConfig
    if (!Array.isArray(lcts) || !lcts) {
        lctConfig = unknownLct
    } else if (lcts.length > 1) {
        lctConfig = LCT_METADATA_DISPATCHER[MULTIPLE_LCTS]
    } else {
        lctConfig = LCT_METADATA_DISPATCHER[lcts[0]] || unknownLct
    }

    const defaultSx = {
        bgcolor: success
            ? theme.palette.success.main
            : theme.palette.primary.main,
    }

    return (
        <Avatar
            sx={{
                ...defaultSx,
                ...sx,
            }}
        >
            <lctConfig.icon aria-label={lctConfig.iconAriaLabel} />
        </Avatar>
    )
}

LctAvatar.defaultProps = {
    success: false,
    sx: {},
}

export default LctAvatar
